export default __webpack_public_path__ + "static/media/short-duration.c64eb9ae.png";